import { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../utils/api';

export function useUserIssueReports({ enabled = true } = {}) {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const loadReports = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await apiClient.listUserIssueReports();
            setReports(Array.isArray(data) ? data : []);
            return data;
        } catch (err) {
            const message = err?.message || 'Failed to load reported issues.';
            setError(message);
            setReports([]);
            throw err;
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (!enabled) {
            return;
        }
        loadReports().catch(() => {
            // error state handled via setError
        });
    }, [enabled, loadReports]);

    return {
        reports,
        loading,
        error,
        refresh: loadReports,
    };
}
